import { ServerEvent } from "@/common/notification";
import { notificationListener } from "@/hooks/notification";
import { useTranscriptionMessaging } from "@/hooks/transcription";
import { TranscriptionMessagesKey } from "@/repository/queryFns";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { MessagingInteractionContentProps, TranscriptionMessage } from "./types";
import { MessagingChatLayout } from "./MessagingChatLayout";
import { useMessagingNotifications } from "./useMessagingNotifications";

export const TranscriptionChatInteractionContent = (
	props: MessagingInteractionContentProps
) => {
	const { interactionId, date, isHistory = false } = props;
	const queryClient = useQueryClient();

	const chatQueryKey = useMemo(
		() => [TranscriptionMessagesKey, date, {}, undefined, interactionId],
		[interactionId]
	);

	useMessagingNotifications(chatQueryKey);

	notificationListener<TranscriptionMessage>(
		ServerEvent.TranscriptionMessage,
		(transcriptionMessage: TranscriptionMessage) => {
			if (isHistory) {
				return;
			}

			queryClient.setQueryData(chatQueryKey, (oldData: any) => {
				if (!oldData) {
					return oldData;
				}

				const updatedPages = [...oldData.pages];
				updatedPages[0] = {
					...updatedPages[0],
					items: [...[transcriptionMessage], ...updatedPages[0].items],
				};

				return { ...oldData, pages: updatedPages };
			});
		}
	);

	const messagingMethods = useTranscriptionMessaging(interactionId, date);

	return (
		<MessagingChatLayout
			messagingMethods={messagingMethods}
			props={props}
		/>
	);
};
